import type { Component } from 'svelte';
import IconWeb from 'virtual:icons/material-symbols/language';
import IconLobby from 'virtual:icons/material-symbols/corporate-fare-rounded';
import IconIfgRequest from 'virtual:icons/material-symbols/mail';
import IconPolitician from 'virtual:icons/material-symbols/person-search-rounded';
import type { SecondarySourceOption } from '#src/types/secondary-sources.ts';

// webSearch and fragdenstaat use the same icons as their citation markers
// (see SourceBadge.svelte), the rest match ToolTypeIcon.svelte.
export const SECONDARY_SOURCE_ICONS: Record<SecondarySourceOption['flagKey'], Component> = {
	webSearch: IconWeb,
	lobbyregister: IconLobby,
	fragdenstaat: IconIfgRequest,
	abgeordnetenwatch: IconPolitician
};
